import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import { transformResultsFromObjectSplitByVendor } from 'util/data';
import { vendorCodes } from 'modules/store/vendors';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE} from 'util/constants';

module.exports = storeModuleFactory({
    name:               'azrRegions',
    endpoint:           endpoints.azrRegions.endpoint,
    timeout:            TIMEOUT_STORE.TIMEOUT_STORE_BIG,
    instanceEndpoint:   endpoints.azrRegions.instanceEndpoint,
    transformResultsFn: json => transformResultsFromObjectSplitByVendor(json.results, vendorCodes.azure).map(item => ({
        ...item,
        fullLabel: `${item.title} [${item.code}]`
    }))
});



// WEBPACK FOOTER //
// ./src/modules/store/azrRegions.js